import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import UserList from "../../../../components/shared/UserList/UserList";
import { type IUser } from "../../../../components/shared/UserList/UserList.types";

const MedicalHistory = () => {
  const navigate = useNavigate();

  const handleViewHistory = useCallback(
    (user: IUser) => {
      navigate(`/settings/yacht/medlog/view-history/${user.userid}`);
    },
    [navigate],
  );

  return <UserList onUserSelect={handleViewHistory} />;
};

export default MedicalHistory;
